import React from 'react';
import { IconProps } from '.';

const SvgArrowChevronRight = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M14.94 12 7.47 4.53l1.06-1.06L17.06 12l-8.53 8.53-1.06-1.06L14.94 12Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgArrowChevronRight;
